import React, { useEffect, useRef, useState } from 'react';

import './style.scss'
import { SEOHeader } from 'views/components';
import { InputField, RadioButton, SelectField } from 'views/components/form-inputs';
import CustomToast from 'views/components/form-inputs/alert';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { InputTextarea } from 'primereact/inputtextarea';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { showTostify } from 'utils/interfaces';
import statesData from 'static.json'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routes } from 'utils/routes';
import { bannerService } from 'services';
import { parseISO } from 'date-fns';
import moment from 'moment';
import { generatePreviewUrl } from 'utils/common-functions';
import axios from 'axios';
import store from 'store'

const initialValue = {
  title: "",
  description: "",
  status: "active",
  start_date: "",
  end_date: "",
  type: "global",
  state: "",
  city: "",
};

const AddBanners = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const toastRef = useRef<any>(null);
  const navigation = useNavigate()
  const params = useParams()
  const id: any = params.id
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [initialData, setInitialData] = useState({ ...initialValue, type: type || "global" });
  const [avatar, setAvatar] = useState<any>([]);

  const formik: any = useFormik({
    initialValues: initialData,
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().required('Title is required'),
      description: Yup.string().required('Description is required'),
      type: Yup.string().required('Type is required'),
      banner_link_url: Yup.string().required('Banner link url is required'),
      start_date: Yup.string().required('Start date is required'),
      end_date: Yup.string().required('End date is required'),
      city: Yup.string().required('City is required'),
      state: Yup.string().required('State is required'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        if (id) {
          delete values.id
          delete values.created_by
          delete values.created_at
          delete values.updated_at
          const data = await bannerService.updateBanner(id, values);
          if (data.error === false) {
            if (values.banner) {
              submitFile(id)
            }
            showTostify(toastRef, 'success', data.message);
            setTimeout(() => {
              navigation(`${routes.banners}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
        else {
          const data = await bannerService.createBanner(values);
          if (data.error === false) {
            if (values.banner) {
              submitFile(data.data.id)
            }
            showTostify(toastRef, 'success', data.message);
            setTimeout(() => {
              navigation(`${routes.banners}?type=${type}`);
            }, 800)
          }
          else {
            showTostify(toastRef, 'error', data.message);
          }
        }
      } catch (err: any) {
        showTostify(toastRef, 'error', err.message);
      } finally {
        setLoading(false);
      }
    }
  });

  useEffect(() => {
    if (id) {
      setLoading(true)
      const getBannerDetails = async () => {
        const data = await bannerService.getBannerDetails(id);
        if (Array.isArray(data?.media) && data?.media.length > 0) {
          setAvatar(data.media);
        } else {
          console.error('Media array is empty or not an array');
        }
        if (!data.error) {
          setInitialData(data)
          const selectedState: any = statesData.states.find(state => state.short_label === data.state);
          if (selectedState) {
            setCities(selectedState.cities);
          } else {
            setCities([]);
          }
          setLoading(false);
        } else {
          showTostify(toastRef, 'error', data.message);
          setLoading(false);
        }
      };
      getBannerDetails();
    }
  }, [id]);

  const handleStateChange = (e: any) => {
    const selectedStateId = e.value;
    formik.setFieldValue('state', selectedStateId);
    const selectedState: any = statesData.states.find(state => state.short_label === selectedStateId);
    if (selectedState) {
      setCities(selectedState.cities);
      formik.setFieldValue('city', '');
    } else {
      setCities([]);
    }
  };
  console.log(formik.values);

  const submitFile = async (id: any) => {
    if (formik.values.banner) {
      const data = new FormData();
      data.append('key', 'banner_desktop');
      data.append('entity_id', `${id}`);
      data.append('files', formik.values.banner);
      data.append('entity_type', "banner");

      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}v1/admin/media`, data, {
          headers: { 'Content-Type': 'multipart/form-data', 'Authorization': store.get(process.env.REACT_APP_ACCESS_TOKEN_KEY || 'bIESIcg42Wb9') }
        });
        showTostify(toastRef, 'success', response?.data?.message);
        formik.resetForm();
      } catch (error) {
        console.error('Error uploading image:', error);
        alert(error);
      }
    }
  }
  return (
    <>
      <CustomToast ref={toastRef} />
      <SEOHeader title="Create Banners" />

      <div className="quicklinks-page">
        <div className="container">
          <div className='bg-white border-round-2xl w-75'>
            <form onSubmit={formik.handleSubmit} >
              <div className="p-4 border-bottom-1 border-primary-color">
                <h2 className='text-start m-0'>{id ? "Edit Banner" : "Add New Banner"}</h2>
              </div>
              <div className="grid m-0 py-4 p-3">
                <div className="grid m-0">
                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="title"
                      label="Title"
                      required={true}
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.title && formik.errors.title}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div>
                      <RadioButton
                        className="custom-form-check"
                        name="status"
                        value={formik.values.status}
                        onChange={(e: any) => formik.setFieldValue('status', e.value)}
                        options={[
                          { label: 'Active', value: 'active', },
                          { label: 'Inactive', value: 'inactive', },
                          { label: 'Draft', value: 'draft', },
                        ]}
                        required={true}
                        label="status"
                        error={formik.touched.status && formik.errors.status}
                      />
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="start_date">Start Date<span className='required-field'>*</span></label>
                      <Calendar
                        id="start_date"
                        name="start_date"
                        value={formik.values.start_date ? parseISO(formik.values.start_date) : null}
                        onChange={(e) => {
                          if (e.value) {
                            const formattedDate = moment(e.value).toISOString();
                            formik.setFieldValue('start_date', formattedDate);
                          } else {
                            formik.setFieldValue('start_date', null);
                          }
                        }}
                        showIcon
                        minDate={new Date()}
                        placeholder="Enter here"
                        className={formik.touched?.start_date && formik.errors?.start_date ? 'p-invalid' : ''}
                      />
                      {formik.touched?.start_date && formik.errors?.start_date && (
                        <Message severity="error" text={formik.errors.start_date} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div className="form-group mb-2">
                      <label htmlFor="end_date">End Date<span className='required-field'>*</span></label>
                      <Calendar
                        id="end_date"
                        name="end_date"
                        value={formik.values?.end_date ? parseISO(formik.values.end_date) : null}
                        onChange={(e) => {
                          if (e.value) {
                            const formattedDate = moment(e.value).toISOString();
                            formik.setFieldValue('end_date', formattedDate);
                          } else {
                            formik.setFieldValue('end_date', null);
                          }
                        }}
                        minDate={new Date()}
                        showIcon
                        placeholder="Enter here"
                        className={formik.touched?.end_date && formik.errors?.end_date ? 'p-invalid' : ''}
                      />
                      {formik.touched?.end_date && formik.errors?.end_date && (
                        <Message severity="error" text={formik.errors.end_date} />
                      )}
                    </div>
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <SelectField
                      name="state"
                      showClear
                      label="State"
                      value={formik.values.state}
                      onChange={handleStateChange}
                      options={statesData?.states?.map(state => ({ label: state.label, value: state.short_label }))}
                      error={formik.touched.state && formik.errors.state}
                      required={true}
                      className="my-custom-class"
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <SelectField
                      name="city"
                      showClear
                      label="City"
                      value={formik.values.city}
                      onChange={(e) => formik.setFieldValue('city', e.value)}
                      options={cities.map(city => ({ label: city, value: city }))}
                      error={formik.touched.city && formik.errors.city}
                      required={true}
                      className="w-full"
                      disabled={cities.length === 0}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <InputField
                      name="banner_link_url"
                      label="Banner Link URL"
                      required={true}
                      value={formik.values.banner_link_url}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik?.touched.banner_link_url && formik.errors.banner_link_url}
                    />
                  </div>

                  <div className="col-12 md:col-6 lg:col-6">
                    <div>
                      <RadioButton
                        className="custom-form-check"
                        name="type"
                        value={formik.values.type}
                        onChange={(e: any) => formik.setFieldValue('type', e.value)}
                        options={[
                          { label: 'Global', value: 'global', },
                          { label: 'Local', value: 'local', },
                        ]}
                        required={true}
                        label="Type"
                        error={formik.touched.type && formik.errors.type}
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-2">
                      <label htmlFor="description">Description <span className="required-field">*</span></label>
                      <InputTextarea
                        placeholder="Enter here"
                        rows={3}
                        className='w-full'
                        name="description"
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik?.touched.description && formik.errors.description && <Message severity="error" text={formik.errors.description} />}
                    </div>
                  </div>

                  <div className="col-6">
                    <div className="form-group mb-2">
                      <label className="label-form mb-1">Banner Image</label>
                    </div>

                    <ul className="fileupload p-list p-list-custom list-none flex flex-wrap gap-2 p-0 m-0">
                      {formik.values.banner && (
                        <li className="p-list-item">
                          <img
                            src={generatePreviewUrl(formik.values.banner)}
                            alt="Banner Preview"
                            width={80}
                            height={80}
                          />
                        </li>
                      )}
                      {avatar && (avatar?.length > 0 && avatar?.length < 4) &&
                        <>
                          {avatar.map((item: any) => {
                            return (
                              <>
                                <li className="p-list-item">
                                  <img src={item?.path} alt="Avatar Preview" width={70} height={70} />
                                </li>
                              </>
                            )
                          })}
                        </>}
                      <li className="p-list-item">
                        <div className="avatar-upload">
                          <label htmlFor="bannerUpload">
                            <i className="pi pi-cloud-upload" style={{ fontSize: '20px' }}></i>
                          </label>
                          <input
                            type="file"
                            id="bannerUpload"
                            name="banner"
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => formik.setFieldValue("banner", e.target.files?.[0] || null)}
                            style={{ visibility: 'hidden' }}
                          />
                        </div>
                      </li>
                    </ul>
                  </div>


                  <div className="col-12 text-center">
                    <Button
                      label={id ? "Edit Banner" : "Add Banner"}
                      type="submit"
                      className="primary"
                      loading={loading}
                      disabled={loading}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBanners;

